import { Flex, Text } from "@chakra-ui/react";
import React from "react";
import { OpportunityTypeSelectorProps } from "./OpportunityTypeSelector.types";

export const OpportunityTypeSelector: React.FC<
  OpportunityTypeSelectorProps
> = ({ active, name, onClick, ...rest }) => {
  return (
    <Flex {...rest}>
      <Text
        as="span"
        textStyle="labelXS"
        onClick={onClick}
        px={"8px"}
        letterSpacing="0.02em"
        textTransform="uppercase"
        lineHeight="20px"
        color={active ? "white" : "text.grey"}
        bg={active ? "brand.main" : undefined}
        borderRadius="22px"
        cursor={onClick && "pointer"}
        fontFamily="heading"
      >
        {name}
      </Text>
    </Flex>
  );
};
